import { Component, Input } from '@angular/core';
import {
  EXTERNAL_BANK_REDIRECT_URLS,
  getBankDisplayName,
} from '../../withdrawal-bank.config';

@Component({
  selector: 'app-withdrawal-external-redirect',
  templateUrl: './withdrawal-external-redirect.component.html',
})
export class WithdrawalExternalRedirectComponent {
  @Input({ required: true }) bankGateway!: string;

  get bankDisplayName(): string {
    return getBankDisplayName(this.bankGateway);
  }

  redirectToBank(): void {
    const redirectUrl = EXTERNAL_BANK_REDIRECT_URLS[this.bankGateway];

    if (!redirectUrl) {
      return;
    }

    window.open(redirectUrl, '_blank', 'noopener,noreferrer');
  }
}
